import { getHospitalDetailSetPiont } from '@/apis/fromBaseApi/hospital_list'
import {getDoctorDetail} from '@/apis/fromBaseApi/doctor'
import Vue from 'vue';
const hos_info_list = []
const hos_info = { 
    hos_code:'',
    hos_area_name:'',
    hos_id:'',
    hos_name:'',
}
async function getHospitalDetail(hos_code) {
    if (!hospitalModule.state.hospitals[hos_code]) {
        const hospital = await getHospitalDetailSetPiont({hospital_area_code:hos_code});
        hospitalModule.mutations.ADD_HOSPITAL(hospitalModule.state,hospital.data)
        console.log(hospitalModule.state.hospitals);
        return hospital.data;
    }
}
async function getHosAndDepAndDocDetail(doc_id) {
    if (!hospitalModule.state.docInfos[doc_id]) {
        const docInfo = await getDoctorDetail(doc_id);
        hospitalModule.mutations.ADD_DOCINFO(hospitalModule.state,docInfo.data)
        console.log(hospitalModule.state.hospitals);
        return docInfo.data;
    }
}
const hospitalModule = {
    state: {
        hospitals: {},
        docInfos:{}
    },
    mutations: {
        ADD_HOSPITAL(state, hospital) {
            state.hospitals = {}
            Vue.set(state.hospitals, hospital.hospital_area_code, hospital);
        },
        ADD_DOCINFO(state, docInfo) {
            state.docInfos = {}
            Vue.set(state.docInfos, docInfo.doc_id, docInfo);
        },
        REMOVE_HOSPITAL(state, hos_code) {
            Vue.delete(state.hospitals, hos_code);
        },
        
    },
    actions: {
        addHospital({ commit }, hospital) {
            commit('ADD_HOSPITAL', hospital);
        },
        removeHospital({ commit }, hos_code) {
            commit('REMOVE_HOSPITAL', hos_code);
        }
    },
    getters: {
        getHospitalById: (state, getters) => async (hos_code) => {
            if (!state.hospitals[hos_code]) {
                return getHospitalDetail(hos_code)
            }
            return state.hospitals[hos_code];
        },
        getHospAndDepAndDocById: (state, getters) => async (doc_id) => {
            if (!state.docInfos[doc_id]) {
                return getHosAndDepAndDocDetail(doc_id)
            }
            return state.docInfos[doc_id];
        },

    }
};

export default hospitalModule;
